import { defineMessages } from 'react-intl';
import { decorateIntlMessages } from '../../common/rosetta_formatted_message';

const i18nMessages = decorateIntlMessages(__filename, defineMessages({
  sort: {
    id: 'sort_select.header',
    description: 'Product list sort label',
    defaultMessage: 'sort'
  },
  newest: {
    id: 'sort_select.sort_id_desc',
    description: 'Product list sort label for new products',
    defaultMessage: 'newest'
  },
  'low > high': {
    id: 'sort_select.sort_price_desc',
    description: 'Product list sort label for price, descending',
    defaultMessage: 'low > high'
  },
  'high > low': {
    id: 'sort_select.sort_price_asc',
    description: 'Product list sort label for price, ascending',
    defaultMessage: 'high > low'
  },
  sale: {
    id: 'sale',
    description: 'Product list label for sale checkbox',
    defaultMessage: 'on sale'
  },
  department: {
    id: 'filter_select.department',
    description: 'Product list filter label for department and top-level navigation',
    defaultMessage: 'department'
  },
  category: {
    id: 'filter_select.category',
    description: 'Product list filter label for category',
    defaultMessage: 'category'
  },
  type: {
    id: 'filter_select.type',
    description: 'Product list filter label for type',
    defaultMessage: 'type'
  },
  collection: {
    id: 'filter_select.collection',
    description: 'Product list filter label for collection',
    defaultMessage: 'collection'
  },
  price: {
    id: 'price_select.header',
    description: 'Product list price label',
    defaultMessage: 'price'
  },
  'Under $50': {
    id: 'price_select.0-49',
    description: 'Product list filter by price under $50',
    defaultMessage: 'Under $50'
  },
  '$50 > $99': {
    id: 'price_select.50-99',
    description: 'Product list filter by price $50 > $99',
    defaultMessage: '$50 > $99'
  },
  '$100 > $249': {
    id: 'price_select.100-249',
    description: 'Product list filter by price $100 > $249',
    defaultMessage: '$100 > $249'
  },
  '$250 > $499': {
    id: 'price_select.250-499',
    description: 'Product list filter by price $250 > $499',
    defaultMessage: '$250 > $499'
  },
  '$500 > $999': {
    id: 'price_select.500-999',
    description: 'Product list filter by price $500 > $999',
    defaultMessage: '$500 > $999'
  },
  '$1000 AND ABOVE': {
    id: 'price_select.1000-and-above',
    description: 'Product list filter by price $1000 AND ABOVE',
    defaultMessage: '$1000 AND ABOVE'
  },
  'Filter By': {
    id: 'filter_sort_wrapper.filter_by',
    description: 'Title of the filter label for the multi-filter, price & sort dropdown',
    defaultMessage: 'Filter By'
  },
  'Price Range': {
    id: 'filter_sort_wrapper.price_range',
    description: 'Title of the price select for the multi-filter, price & sort dropdown',
    defaultMessage: 'Price Range'
  },
  'Sort By': {
    id: 'filter_sort_wrapper.sort_by',
    description: 'Title of the sort label for the multi-filter, price & sort dropdown',
    defaultMessage: 'Sort By'
  },
  'Filter & Sort By': {
    id: 'filter_sort_wrapper.label',
    description: 'Label for the multi-filter, price & sort dropdown',
    defaultMessage: 'Filter & Sort By'
  }
}));

export default () => i18nMessages;
